import MainButton from 'components/MainButton'
import styled from 'styled-components'

const UserStatusDisplay = ({
  userAnswers,
  totalItems,
  startNext,
  isMobile = false,
}: {
  userAnswers: Answer[] | undefined
  totalItems: number
  startNext: () => void
  isMobile?: boolean
}) => {
  if (!userAnswers || !userAnswers.length) return null
  const locales = {
    de: {
      thanks: 'Vielen Dank fürs Mitmachen!',
      partly:
        userAnswers.length === totalItems ? (
          <>Sie haben alle {totalItems} Produkte entsorgt.</>
        ) : (
          <>
            Sie haben bisher{' '}
            <b>
              {userAnswers.length} von {totalItems} Produkten{' '}
            </b>
            zugeordnet. Weiter unten finden Sie Ihre Auswertung. Wollen Sie
            weiter machen?
          </>
        ),
      fully: 'Glückwunsch! Sie haben alle Produkte entsorgt.',
      tipp: 'Weiter unten finden Sie die Auswertung!',
    },
  }

  const hasItemsLeft = userAnswers.length < totalItems

  return (
    <>
      {/* <UserStatusDisplayContainer>
        <Thanks>{locales.de.thanks}</Thanks>

        {hasItemsLeft && <CallToAction>{locales.de.partly}</CallToAction>}
        {!hasItemsLeft && <CallToAction>{locales.de.fully}</CallToAction>}

        {hasItemsLeft && (
          <MainButton label={'Weiter machen'} secondary onClick={startNext} />
        )}
      </UserStatusDisplayContainer> */}

      <ProductDisplayRoot className='pdr' isFinished={!hasItemsLeft}>
        <ImageContainer>
          <Wrapper>
            <Thanks style={{ color: hasItemsLeft ? '#fff' : undefined }}>
              {locales.de.thanks}
            </Thanks>
            {hasItemsLeft && (
              <CallToAction
                style={{ color: hasItemsLeft ? '#fff' : undefined }}
              >
                {locales.de.partly}
              </CallToAction>
            )}
            {!hasItemsLeft && <CallToAction>{locales.de.fully}</CallToAction>}

            {/* {items.map((item, index) => {
            return <img src={require(`../../images/Products/${item.image}.png`)} />
          })} */}
          </Wrapper>
        </ImageContainer>
        <Count>
          {hasItemsLeft && (
            <MainButton
              label={'10 weitere zuordnen'}
              secondary
              onClick={startNext}
            />
          )}
        </Count>
      </ProductDisplayRoot>
    </>
  )
}
const UserStatusDisplayContainer = styled.div`
  background-color: var(--beige-bright-2);
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  margin-top: 60px;
  line-height: 1.4em;
`

const Thanks = styled.div`
  font-weight: 700;
  margin-bottom: 15px;
`
const CallToAction = styled.div`
  font-size: 15px;
  line-height: 1.4em;
`
const Tip = styled.div``

const ProductDisplayRoot = styled.div<{ isFinished: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 300px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-image: ${(props) =>
    props.isFinished
      ? `url(${require('../../images/product_display_bg_finish.png')});`
      : `url(${require('../../images/product_display_bg_info.png')});`};
  background-size: contain;
  margin-bottom: 60px;
  margin-top: 60px;
  img {
    max-width: 200px;
  }
`
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 293px;
  height: 293px;
  position: absolute;
  top: 0;
  left: 3px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 200px;
    height: 200px;
  }
`

const Wrapper = styled.div.attrs({ className: 'wrapper' })`
  display: flex;
  line-height: 1.4em;
  padding-left: 50px;
  padding-right: 50px;
  flex-wrap: wrap;
  text-align: center;
`
const Count = styled.div.attrs({ className: 'count' })`
  position: absolute;
  bottom: 5px;
  font-size: 16px;
  display: flex;
  align-content: center;
  justify-content: center;
  b {
    font-size: 18px;
  }
`
export default UserStatusDisplay
